import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loading from '../CircularLoading';
import { fetchWeChatQRCode } from '../../actions/integrations';

export class WeChatChannelContentComponent extends Component {
    static propTypes = {
        channelState: PropTypes.object.isRequired,
        qrCodeError: PropTypes.string.isRequired,
    };

    state = {
        isQrCodeLoaded: false,
    };

    onQrLoad = () => {
        this.setState({
            isQrCodeLoaded: true,
        });
    };

    render() {
        const { channelState, qrCodeError } = this.props;

        if (channelState.hasError) {
            return (
                <a className="error-link" onClick={fetchWeChatQRCode}>
                    {qrCodeError}
                </a>
            );
        }

        const loadingStyle = {
            height: 40,
            width: 40,
            margin: 'auto',
        };

        return (
            <div>
                {!this.state.isQrCodeLoaded && <Loading dark={true} style={loadingStyle} />}
                {channelState.qrCode && (
                    <img
                        alt="WeChat QR Code"
                        style={{ width: '40%', visibility: this.state.isQrCodeLoaded ? 'visible' : 'hidden' }}
                        src={channelState.qrCode}
                        onLoad={this.onQrLoad}
                    />
                )}
            </div>
        );
    }
}

export default connect(({ ui: { text } }) => {
    return {
        qrCodeError: text.wechatQRCodeError,
    };
})(WeChatChannelContentComponent);
